
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.276 11.007C5.684 8.431 5 5.4 5 5.4s0-.5.5-.8c0-.7-.1-1.7.1-2C5.9 2.2 5.8 1 7 1s1.1 1.2 1.4 1.6c.2.4.1 1.4.1 2 .5.3.5.8.5.8l-1.316 5.603L10 11.5v1H7.338C7.137 13.39 7 14.022 7 14.1c-.031-.093-.12-.466-.385-1.616l-.339-1.477zm.339 1.477c.026.112-.025-.107 0 0L3.9 12.5v-1l2.376-.493.339 1.477z"}})])
          )
        }
      }
    